import * as yup from 'yup';

export const useShotgunDetailsStepFormSchema = () => {
  const schema = yup.object({
    holdShotgun: yup.string().required('This field is required'),
    calibre: yup.string(),
    actionType: yup.string().when('holdShotgun', {
      is: (holdShotgun: any) => holdShotgun === '1',
      then: (yupSchema) => yupSchema.required('Action/Type is a required field'),
    }),
    make: yup.string().when('holdShotgun', {
      is: (holdShotgun: any) => holdShotgun === '1',
      then: (yupSchema) => yupSchema.required('Make is a required field'),
    }),
    serialNumber: yup.string(),
    securityArrangements: yup.string().required('This field is required'),
    securityDetails: yup.string(),
    securityType: yup.string(),
    securityAdditionalInformation: yup.string(),

    certificateHolder: yup.string().required('This field is required'),
    certificateDetails: yup.string(),
    ammoStorage: yup.string(),
  });

  return { schema };
};
